import Api from "./Api";
import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { servicosSaudeApiConfig } from "./config";
import { FiltroPrestadorDTO } from "./cadastro/saude/FiltroPrestadorDTO";
import { PrestadorDTO } from "./cadastro/saude/PrestadorDTO";
import { PrestadorPagedResultDTO } from "./cadastro/saude/PrestadorPagedResultDTO";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";

class ServicosSaudePrestadorApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  pesquisarPrestador(filtro: FiltroPrestadorDTO): Promise<PrestadorPagedResultDTO> {
    return this.get<PrestadorPagedResultDTO>("/prestador", { params: filtro })
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        console.error(err);
        throw new Error("Falha ao filtrar prestadores");
      });
  }

  obterPrestador(id: number): Promise<PrestadorDTO> {
    return this.get<PrestadorDTO>(`/prestador/${id}`)
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        console.error(err);
        throw new Error("Falha ao obter prestador");
      });
  }

  cadastrarPrestador(prestadorDTO: PrestadorDTO) {
    return this.post<PrestadorDTO>("/prestador", prestadorDTO).catch((err) => {
      if ((err.response?.data.detail || "").includes("devem estar cadastradas nas especialidades do prestador")) {
        throw Error(err.response?.data.detail);
      } else if ((err.response?.data.detail || "").includes("Prestador já cadastrado com o CNPJ")) {

        const cnpjFormatado = prestadorDTO.cpfCnpj.length == 14
          ? prestadorDTO.cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5")
          : prestadorDTO.cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
        throw Error(`Prestador já cadastrado com o documento ${cnpjFormatado}`);
      } else {
        throw Error("Falha ao cadastrar prestador.");
      }
    });
  }

  atualizarPrestador(prestadorDTO: PrestadorDTO) {
    return this.put<PrestadorDTO>(`/prestador/${prestadorDTO.id}`, prestadorDTO).catch((err) => {
      if ((err.response?.data.detail || "").includes("devem estar cadastradas nas especialidades do prestador")) {
        throw Error(err.response?.data.detail);
      } else {
        throw Error("Falha ao cadastrar prestador.");
      }
    });
  }

  excluirPrestador(id: number): Promise<any> {
    return this.delete(`/prestador/${id}`).catch((err) => {
      throw new Error("Falha ao excluir prestador");
    });
  }

  pesquisarPrestadorPorNome(nome: string): Promise<PrestadorResumidoModel[]> {
    return this.get<PrestadorResumidoModel[]>(`/prestador/listar-todos-por/${nome}`, {})
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        console.error(err);
        throw new Error("Falha ao filtrar prestadores");
      });
  }
  
  pesquisarPrestadorPorEspecialidadeENome(isEspecialidade: number, nome: string): Promise<PrestadorResumidoModel[]> {
    return this.get<PrestadorResumidoModel[]>(`/prestador/especialidade/${isEspecialidade}/listar-todos-por/${nome}`, {})
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        console.error(err);
        throw new Error("Falha ao filtrar prestadores");
      });
  }

  pesquisarPrestadorCNPJCadastrado(cnpj: string): Promise<PrestadorResumidoModel | null> {
    return this.get<PrestadorResumidoModel>(`/prestador/cnpj/${cnpj}`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        if (err.response?.status == 404 && (err.response.data?.detail || "" ).includes("não encontrado")) {
          return null;
        }
      });
  }
}

export const servicosSaudePrestadorApi = new ServicosSaudePrestadorApi(servicosSaudeApiConfig);
